import { jsx } from "react/jsx-runtime";
import { Button, styled } from "@mui/material";
const ResetButton = styled((props) => /* @__PURE__ */ jsx(Button, { variant: "text", ...props }))(({ theme }) => ({
  textTransform: "none",
  ...theme.typography.subtitle1
}));
export {
  ResetButton
};
//# sourceMappingURL=ResetButton.js.map
